<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3 d-flex flex-column"
    :class="`${
      isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'
    } ${sidebarType}`"
  >
    <div class="sidenav-header">
      <img
        :src="logo"
        class="expand-logo-rounded"
        alt="main_logo"
      />
    </div>
    <button
      v-if="isMobile && isSidebarOpen"
      class="sidenav-close-btn"
      aria-label="Close sidebar"
      @click="closeSidebar"
    >
      <i class="material-icons">close</i>
    </button>
    <hr class="horizontal light mt-0 mb-2" />
    <sidenav-list />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import branding from "../../branding";
import { mapState } from "vuex";
export default {
  name: "Index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo: branding.sidebarLogo,
      isMobile: window.innerWidth <= 1024,
      isSidebarOpen: false,
    };
  },
  computed: {
    ...mapState(["isRTL", "sidebarType", "isDarkMode"]),
  },
  watch: {
    $route() {
      this.collapseSidebarOnMobile();
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    window.addEventListener("resize", this.handleResize);

    // Lock body scroll and track open state when sidebar is open on mobile
    const parent = document.querySelector(".g-sidenav-show");
    if (parent) {
      this._sidenavObserver = new MutationObserver(() => {
        if (window.innerWidth > 1024) {
          document.body.style.overflow = "";
          this.isSidebarOpen = false;
          return;
        }
        if (parent.classList.contains("g-sidenav-pinned")) {
          document.body.style.overflow = "hidden";
          this.isSidebarOpen = true;
        } else {
          document.body.style.overflow = "";
          this.isSidebarOpen = false;
        }
      });
      this._sidenavObserver.observe(parent, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
    window.removeEventListener("resize", this.handleResize);
    if (this._sidenavObserver) {
      this._sidenavObserver.disconnect();
    }
    document.body.style.overflow = "";
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
      if (window.innerWidth > 1024) {
        document.body.style.overflow = "";
        this.isSidebarOpen = false;
      }
    },

    collapseSidebarOnMobile() {
      if (window.innerWidth <= 1024) {
        const sidenav = document.getElementsByClassName("g-sidenav-show")[0];
        if (sidenav && sidenav.classList.contains("g-sidenav-pinned")) {
          sidenav.classList.remove("g-sidenav-pinned");
          sidenav.classList.add("g-sidenav-hidden");
          this.$store.state.isPinned = true;
        }
        document.body.style.overflow = "";
      }
    },

    closeSidebar() {
      this.collapseSidebarOnMobile();
    },

    handleClickOutside(event) {
      if (window.innerWidth > 1024) return;
      // Ignore clicks on the hamburger toggler (it handles its own toggle)
      if (event.target.closest(".sidenav-toggler-inner")) return;
      const sidenavEl = this.$el;
      if (!sidenavEl.contains(event.target)) {
        this.collapseSidebarOnMobile();
      }
    },
  },
};
</script>
<style scoped>
.expand-logo-rounded {
  width: 100%;
  padding: 10px;
  border-radius: 20px;
}

/* Sidebar uses flexbox so the nav list fills all available space.
   align-items: stretch overrides Bootstrap .navbar's align-items: center
   which would horizontally center children in a column layout. */
.sidenav {
  display: flex !important;
  flex-direction: column !important;
  flex-wrap: nowrap !important;
  align-items: stretch !important;
  overflow: visible !important;
}

.sidenav .sidenav-header,
.sidenav > hr {
  flex-shrink: 0;
}

.sidenav :deep(.navbar-collapse) {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: auto !important;
  max-height: none !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -webkit-overflow-scrolling: touch;
}

/* Mobile: flush sidebar to left edge, full-height */
@media (max-width: 1199.98px) {
  .sidenav {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    border-radius: 0 !important;
    overscroll-behavior: contain;
    height: 100dvh !important;
    height: 100vh !important;
    max-height: 100dvh !important;
    max-height: 100vh !important;
  }

  @supports (height: 100dvh) {
    .sidenav {
      height: 100dvh !important;
      max-height: 100dvh !important;
    }
  }

  .sidenav :deep(.navbar-collapse) {
    padding-bottom: 20px;
  }
}

/* X close button — floats outside the right edge of the sidebar */
.sidenav-close-btn {
  position: absolute;
  top: calc(16px + env(safe-area-inset-top)); /* env() is 0 on the website */
  left: 100%;
  margin-left: 8px;
  background: rgba(0, 0, 0, 0.45);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  line-height: 1;
  transition: background 0.2s ease;
}

.sidenav-close-btn:hover {
  background: rgba(0, 0, 0, 0.65);
}

.sidenav-close-btn .material-icons {
  font-size: 22px;
}
</style>
